var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a3349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65 20.23c-.02-.61 0-1.35.15-2.02.17-.71 1.13-4.78 1.13-4.78s-.28-.56-.28-1.39c0-1.3.75-2.27 1.69-2.27.8 0 1.18.6 1.18 1.32 0 .8-.51 2-.77 3.11-.22.93.47 1.69 1.39 1.69 1.66 0 2.78-2.14 2.78-4.67 0-1.92-1.3-3.36-3.65-3.36-2.66 0-4.32 1.99-4.32 4.2 0 .77.22 1.31.58 1.72.16.19.19.27.13.49l-.18.7c-.06.22-.24.3-.44.22-1.23-.5-1.8-1.84-1.8-3.36 0-2.49 2.1-5.49 6.27-5.49 3.35 0 5.56 2.43 5.56 5.03 0 3.44-1.91 6.02-4.74 6.02-.95 0-1.84-.51-2.14-1.09 0 0-.51 2.02-.62 2.41-.19.68-.55 1.35-.88 1.88-.59.36-1.02-.08-1.04-.38Z",
    fillRule: "evenodd"
  }))));
};

export default SvgPinterest;